import React from "react";

export function MenuItemSmallButton({
  onClick,
  className,
  children,
  ariaLabel,
}: {
  onClick: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  children?: React.ReactNode | React.ReactNode[];
  ariaLabel?: string;
}) {
  return (
    <button
      className={"menu-underline-button " + (className || "")}
      onClick={onClick}
      aria-label={ariaLabel}
      type="button"
    >
      {children}
    </button>
  );
}
